import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, KlaviyoIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof KlaviyoIntegrationResponseDataSchema>>

const queryKey = ["klaviyoIntegrationConfiguration"]

export const klaviyoIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/klaviyo`)

      return response.data.data
    },
  })
}
